import { Injectable } from "@angular/core";
import { NetCoreEventTypes } from "./netcore.events";
import { environment } from "src/environments/environment";
interface NetCoreUserProperties {
    "pk^mobile": string;
    email: string;
    NAME: string;
    mobile: string;
    AGE: number;
    CUSTOMER_ID: string;
    GENDER: string;
    MARITAL_STATUS: string;
    CREDIT_RANGE: string;
    USER_TYPE: string;
    USER_CITY: string;
    WORK_EMAIL: string;
    // work email
    COMPANY_NAME: string;
    COMPANY_TYPE: string;
    BANK_NAME: string;
    BANK_BRANCH: string;
    USER_SALARY: number;
}

interface IAuthUserProperties {
    email: string;
    name: string;
    mobile: string;
    age: number;
    customer_id: string;
    gender: string;
}

@Injectable({
    providedIn: "root",
})
export class NetCoreService {
    private isInitialized = false;

    constructor() {
        this.initializeNetcore();
    }

    private initializeNetcore(): void {
        if (this.isInitialized) return;

        // Load Netcore script dynamically
        const script = document.createElement("script");
        script.src = "//cdnt.netcoresmartech.com/smartechclient.js";
        script.async = true;
        script.onload = () => {
            // Initialize Netcore with environment credentials
            (window as any).smartech("create", environment.netcoreConfig.apiKey);
            (window as any).smartech("register", environment.netcoreConfig.siteId);
            this.isInitialized = true;
        };
        document.head.appendChild(script);
    }

    trackUserProperties(parameters: Partial<NetCoreUserProperties>): void {
        if (!this.isInitialized) {
            console.warn("Netcore not initialized yet");
            return;
        }
        (window as any).smartech("contact", "1", parameters);
        (window as any).smartech("identify", parameters["pk^mobile"]);
    }

    trackNetcoreEvent(event: NetCoreEventTypes, parameters: IAuthUserProperties): void {
        if (!this.isInitialized) {
            console.warn("Netcore not initialized yet");
            return;
        }
        (window as any).smartech("dispatch", event, {
            email: parameters.email,
            name: parameters.name,
            mobile: parameters.mobile,
            age: parameters.age,
            customer_id: parameters.customer_id,
            gender: parameters.gender,
        });
    }
}
